import { Box, CircularProgress, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { apiVariable } from "../../../api/apiVariable";
import { assignedDriverTableColumns } from "../../../data/FormColumns/Fleet/assignedDriverTableColumns";

const fetchAssignedDrivers = async (
  token: string | null | undefined,
  truckId: string,
) => {
  const { data } = await axios.get(
    `${apiVariable}/getAssignedDriverHistoryOnTruck/${truckId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return data;
};

interface AssignedDriversProps {
  truckId: string;
  token: string | null | undefined;
}

const AssignedDrivers = ({ truckId, token }: AssignedDriversProps) => {
  const {
    data: assignedDrivers,
    isLoading: isLoadingDrivers,
    isError: isErrorDrivers,
    error: driverError,
  } = useQuery({
    queryKey: ["assignedDrivers", truckId],
    queryFn: () => fetchAssignedDrivers(token, truckId),
    enabled: !!truckId,
  });

  if (isLoadingDrivers) {
    return <CircularProgress />;
  }

  if (isErrorDrivers) {
    return (
      <Typography color="error">
        Error: {(driverError as Error).message}
      </Typography>
    );
  }

  return (
    <Box sx={{ height: 400, width: { xs: "100%", sm: "80%" }, minWidth: 0 }}>
      <DataGrid
        rows={assignedDrivers || []}
        columns={assignedDriverTableColumns}
      />
    </Box>
  );
};

export default AssignedDrivers;
